export type ApiErrorResponse = {
    timestamp?: number;
    status: number;
    error?: string;
    message: string;
    path?: string;
};

export class ApiError {
    response: ApiErrorResponse;

    constructor(response: ApiErrorResponse) {
        this.response = response;
    }
}
